<template>
    <div
        :class="[
            getStyles,
            borderStyle,
            backgroundStyle,
            { 'shadow-muval-5': !inline },
            { 'items-center': !triggerText },
        ]"
        class="container relative flex gap-2 rounded-muval-1 border-l-4 py-0.5 pl-2 antialiased"
    >
        <div class="absolute left-2.5 top-2 w-fit">
            <SvgIcon
                :name="getIcon"
                class="h-5 w-5"
            />
        </div>

        <p
            v-if="!triggerText"
            class="container py-1.5 pl-8 pr-4 text-sm font-normal text-muval-gray-1"
        >
            <slot />
        </p>

        <CollapsibleRoot
            v-else
            v-model:open="isOpen"
            :default-open="openByDefault"
            class="container pl-8 pr-4"
        >
            <CollapsibleTrigger
                class="flex cursor-pointer items-center gap-1.5 py-1.5 text-sm font-medium text-muval-gray-1"
            >
                <span>{{ triggerText }}</span>
                <SvgIcon
                    name="system-chevron-down"
                    class="size-4 transition-transform duration-150"
                    :class="{ '-rotate-90': !isOpen }"
                />
            </CollapsibleTrigger>
            <CollapsibleContent class="CollapsibleContent">
                <p class="pb-1.5 text-sm font-normal text-muval-gray-1">
                    <slot />
                </p>
            </CollapsibleContent>
        </CollapsibleRoot>
    </div>
</template>
<script setup>
const props = defineProps({
    type: {
        type: String,
        required: false,
        default: 'danger',
        validator: (s) => ['info', 'alert', 'warning'].includes(s),
    },
    inline: {
        type: Boolean,
        required: false,
        default: false,
    },
    icon: {
        type: [String, null],
        required: false,
        default: null,
    },
    triggerText: {
        type: String,
        required: false,
        default: null,
    },
    openByDefault: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const isOpen = ref(props.openByDefault);

const getIcon = computed(() => {
    if (props.icon) {
        return props.icon;
    }
    switch (props.type) {
        case 'warning':
            return 'system-warning';
        case 'alert':
            return 'system-information-filled';
        default:
            return 'system-information-filled';
    }
});

const getStyles = computed(() => {
    if (props.inline) {
        switch (props.type) {
            case 'info':
                return 'text-muval-information';
            case 'alert':
                return 'text-muval-amber';
            default:
                return 'text-error';
        }
    } else {
        switch (props.type) {
            case 'info':
                return 'text-muval-information ';
            case 'alert':
                return 'text-muval-amber ';
            default:
                return 'text-error ';
        }
    }
});

const borderStyle = computed(() => {
    switch (props.type) {
        case 'info':
            return 'border-muval-teal';
        case 'alert':
            return 'border-muval-amber';
        default:
            return 'border-error';
    }
});

const backgroundStyle = computed(() => {
    // if (!props.inline) {
    //     return 'bg-white';
    // }
    switch (props.type) {
        case 'info':
            return 'bg-muval-teal/10';
        case 'alert':
            return 'bg-muval-amber/10';
        default:
            return 'bg-muval-red-2';
    }
});
</script>
<style scoped>
.CollapsibleContent {
    overflow: hidden;
}
.CollapsibleContent[data-state='open'] {
    animation: slideDown 150ms ease-in-out;
}
.CollapsibleContent[data-state='closed'] {
    animation: slideUp 150ms ease-in-out;
}

@keyframes slideDown {
    from {
        height: 0;
    }
    to {
        height: var(--radix-collapsible-content-height);
    }
}

@keyframes slideUp {
    from {
        height: var(--radix-collapsible-content-height);
    }
    to {
        height: 0;
    }
}
</style>
